import React, { useState } from 'react';
import { FileSpreadsheet, Upload, FileText } from 'lucide-react';
import './BomUploader.css';

export default function BomUploader({ onUpload, loading }) {
  const [file, setFile] = useState(null);
  const [inlineText, setInlineText] = useState('');

  const readFileText = (inputFile) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(new Error('Could not read BOM file.'));
      reader.readAsText(inputFile);
    });

  const handleFileSubmit = async () => {
    if (!file || loading) return;
    const text = await readFileText(file);
    onUpload(text, file.name);
  };

  const handleTextSubmit = () => {
    if (!inlineText.trim() || loading) return;
    onUpload(inlineText.trim(), 'Pasted BOM');
  };

  return (
    <section className="bom-uploader animate-in">
      <div className="bom-header">
        <div className="bom-title">
          <FileSpreadsheet size={16} />
          <span>Upload BOM</span>
        </div>
        <div className="bom-sub mono">CSV / TXT with `component,qty,specs`</div>
      </div>

      <div className="bom-grid">
        <div className="bom-card">
          <label className="bom-file-input">
            <input
              type="file"
              accept=".csv,.txt,.tsv"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              disabled={loading}
            />
            <Upload size={15} />
            <span>{file ? file.name : 'Choose BOM file'}</span>
          </label>
          <button className="bom-btn" onClick={handleFileSubmit} disabled={!file || loading}>
            Import BOM File
          </button>
        </div>

        <div className="bom-card">
          <div className="bom-inline-head">
            <FileText size={14} />
            <span>Paste BOM lines</span>
          </div>
          <textarea
            className="bom-text"
            value={inlineText}
            onChange={(e) => setInlineText(e.target.value)}
            placeholder={'ESP32 Dev Board,1,WiFi + BLE\nL298N Motor Driver,1,2A dual H-bridge\n18650 Battery Pack,2,2200mAh'}
            rows={4}
          />
          <button className="bom-btn ghost" onClick={handleTextSubmit} disabled={!inlineText.trim() || loading}>
            Parse Pasted BOM
          </button>
        </div>
      </div>
    </section>
  );
}
